/**
 * Defines unique identifiers for error causes.
 * These IDs are sent to the client via the X-ERROR-CAUSE-ID header
 * and can be used for displaying translated, user-friendly error messages on the client.
 */

// const httpStatus = (code: number) => {
//   return code - 400;
// }

export enum CauseId {

  // Access errors
  ACCESS_DENIED = 0xA0001003, // 0xA0001000 + (403 - 400)
  NOT_LOGGED_IN = 0xA0002001, // 0xA0002000 + (401 - 400)
  EMAIL_EXISTS  = 0xA0003103, // 0xA0003100 + (403 - 400)
  ID_NUMBER_EXISTS = 0xA0003203, // 0xA0003200 + (403 - 400)
  PASSPORT_EXISTS = 0xA0003303, // 0xA0003300 + (403 - 400)
  PHONE_EXISTS = 0xA00034003, // 0xA0005000 + (403 - 400)
  LOGIN_FAILED = 0xA0004003, // 0xA0004000 + (403 - 400)
  SESSION_EXPIRED = 0xA0005001, // 0xA0005000 + (401 - 400)
  PASSWORD_WRONG = 0xA0006003, // 0xA0006000 + (403 - 400)
  ACCOUNT_LOCKED = 0xA0006101, // 0xA0006100 + (401 - 400)
  USER_NOT_FOUND = 0xA0006204, // 0xA0006200 + (404 - 400)

  // General errors
  INVALID_REQUEST = 0xB0000000, // 0xB0000000 + (400 - 400)
  CONNECTION_FAILED = 0xB0001064, // 0xB0001000 + (500 - 400)
  UNEXPECTED_RESPONSE = 0xB0002064, // 0xB0002000 + (500 - 400)
  NOT_FOUND = 0xB0003004, // 0xB0003000 + (404 - 400)
  SERVER_ERROR = 0xB0004064, // 0xB0004000 + (500 - 400)
  SERVICE_UNAVAILABLE = 0xB0005067, // 0xB0005000 + (503 - 400)
  UNEXPECTED_ERROR = 0xBAD00000,

  // Data issues
  INVALID_DATA = 0xD0000016, // 0xD0000000 + (422 - 400)
  INVALID_CREDENTIALS = 0xD0001016, // 0xD0001000 + (422 - 400)
  INVALID_ACCOUNT_ID = 0xD0002016, // 0xD0002000 + (422 - 400)
  INVALID_PHONE = 0xD0002116, // 0xD0002100 + (422 - 400)
  INVALID_EMAIL = 0xD0002216, // 0xD0002200 + (422 - 400)
  INVALID_ID_NUMBER = 0xD0002316, // 0xD0002300 + (422 - 400)
  INVALID_PASSPORT = 0xD0002416, // 0xD0002400 + (422 - 400)
  INVALID_PASSWORD = 0xD0003016, // 0xD0003000 + (422 - 400)
  PASSWORD_TOO_SHORT = 0xD0003116, // 0xD0003100 + (422 - 400)
  PASSWORD_REQUIRED = 0xD0003216, // 0xD0003200 + (422 - 400)
  DUPLICATE_ENTRY = 0xD0004009, // 0xD0004000 + (409 - 400)
  VALIDATION_ERROR = 0xD0005000, // 0xD0005000 + (400 - 400)
  CONFIGURATION_ERROR = 0xD0006064, // 0xD0006000 + (500 - 400)
  EXTERNAL_SERVICE_ERROR = 0xD0007064, // 0xD0007000 + (500 - 400)
}

/**
 * Extracts the HTTP status code from a CauseId.
 * Each CauseId has the status code embedded in its lower 7 bits.
 * 
 * @param causeId The CauseId to extract the status code from
 * @returns The HTTP status code (e.g., 400, 401, 403, 422, 500)
 */
export function getHttpStatusCode(causeId: CauseId | null): number {
  return causeId == null ? 500 : (causeId & 0x7F)+400;
}
